import { FC } from "react"
import cx from "classnames"
import { BiSolidFileJson } from "react-icons/bi"

type Props = {
  className?: string
} & React.HTMLAttributes<HTMLOrSVGElement>

const JsonIcon: FC<Props> = ({ className, ...rest }: Props) => {
  return (
    <BiSolidFileJson
      className={cx("w-5 h-5 transition-opacity", className)}
      {...rest}
    />
  )
}

export default JsonIcon
